import { CapoPlugin } from "/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];